export default {
  en: {
    title: 'API keys',
    alpha: 'Alpha',
    description: 'Access the Risk Ledger API with an API key. Take a look at our {link}.',
    apiDocs: 'API documentation',
    fetchError: 'Failed to get API keys, contact support for help.',
    retry: 'Retry',
    noKeys: 'No API keys to display',
    noKeysDescription: 'Create a new key above for calling the Risk Ledger API',
    creation: 'Created {date} by {user}',
    deletedUser: 'Deleted user',
    create: {
      title: 'Create API key',
      description:
        'Create an API key to securely connect as your organisation to the Risk Ledger API.',
      name: 'API key name',
      namePlaceholder: 'Name...',
      create: 'Create',
      cancel: 'Cancel',
      error: 'Failed to create new API key, contact support for help.',
      secretTitle: 'Your API key secret',
      secretDescription:
        "Your API key is ready! Here's your unique secret key - we'll only show this once. If you lose it, you'll need to create a new key.",
      secret: 'Secret',
      close: 'Close',
      copy: 'Copy to clipboard',
      copied: 'Copied API key secret to clipboard.',
      copyError: 'Failed to copy API key secret.',
    },
    delete: {
      tooltip: 'Delete API key',
      title: 'Delete API key',
      areYouSure: 'Are you sure you want to delete this key?',
      consequence: 'You will no longer be able to use it to access the Risk Ledger API.',
      cancel: 'Cancel',
      delete: 'Delete',
      error: 'Failed to delete API key, contact support for help.',
    },
  },
};
